<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a class="breadcrumb-link" routerLink="/configuration-options"
            >{{ 'configurationOptionModule.configurationOptions' | translate }}
          </a>
        </li>
        <li class="breadcrumb-item active">
          {{ (configurationOption$ | async)?.key }}
        </li>
      </ol>
    </nav>
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ (configurationOption$ | async)?.key }}
      </h1>
    </div>
  </header>
  <!-- End Page Header -->

  <!-- Nav -->
  <nav attr.aria-label="{{ 'wcag.confingMenu' | translate }}">
    <ul
      class="nav nav-tabs align-items-center mb-3"
      *ngIf="configurationOption$ | async as configurationOption"
      role="tablist"
    >
      <!-- WCAG SKIP link -->
      <!-- <li class="nav-item">
         <a
          href="#configOptionsContent"
          class="nav-link visually-hidden-focusable"
          ><span>{{ 'wcag.skipNavigation' | translate }}</span></a
        >
      </li> -->
      <!-- END WCAG skip link -->
      <li class="nav-item">
        <a
          [routerLink]="['/configuration-options/', configurationOption.key]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="nav-link"
          role="tab"
          #rla1="routerLinkActive"
          [attr.aria-selected]="rla1.isActive ? 'true' : 'false'"
          aria-controls="configOptionsContent"
        >
          <i role="img" class="fa fa-cube" aria-hidden="true"></i>
          {{ 'general.general' | translate }}
        </a>
      </li>
    </ul>
  </nav>
  <!-- End Nav -->

  <div class="w-100" id="configOptionsContent">
    <router-outlet></router-outlet>
  </div>
</div>
